import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";

export function useSavedListings() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["saved-listings", user?.id],
    enabled: !!user,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("saved_listings" as any)
        .select("*")
        .order("created_at", { ascending: false });
      if (error) throw error;
      return (data ?? []) as unknown as Array<{ id: string; listing_id: string; created_at: string }>;
    },
  });
}

export function useToggleSavedListing() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async ({ listingId, saved }: { listingId: string; saved: boolean }) => {
      if (!user) throw new Error("Sign in to save listings");
      if (saved) {
        const { error } = await supabase
          .from("saved_listings" as any)
          .delete()
          .eq("user_id", user.id)
          .eq("listing_id", listingId);
        if (error) throw error;
        return { listingId, saved: false };
      } else {
        const { error } = await supabase
          .from("saved_listings" as any)
          .insert({ user_id: user.id, listing_id: listingId });
        if (error) throw error;
        return { listingId, saved: true };
      }
    },
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: ["saved-listings", user?.id] });
      toast.success(res.saved ? "Listing saved" : "Removed from saved");
    },
    onError: (e: any) => toast.error(e.message ?? "Could not update"),
  });
}
